<template>
    <div class="row mx-lg-auto">
        <div class="col-md-6 mx-lg-auto ">
        <div class="input-card mx-lg-auto">
            <div class="input-card-form">
              <label class="form-control text-left">Nombre</label>
              <input type="text" v-model="allresponses.name"  class="form-control text-left" placeholder="Ej: Pedro" @change="ValidarRespuesta" @keypress="ValidarRespuesta" />
            </div>
          </div>
        </div>
    </div>
    <div class="row mx-lg-auto" style="margin-top:10px;">
        <div class="col-md-6 mx-lg-auto ">
        <div class="input-card mx-lg-auto">
            <div class="input-card-form">
              <label class="form-control text-left">Apellidos</label>
              <input type="text" v-model="allresponses.surnames"  class="form-control text-left" placeholder="Ej: López Rodriguez" @change="ValidarRespuesta" @mouseleave="ValidarRespuesta" @keypress="ValidarRespuesta" />
            </div>
          </div>
        </div>
    </div>
</template>

<script>

export default {
  name: 'NombreCompleto',
  props: {

      response: String,
      FormularioTag: String,
      idQuestion: Number,
      allresponses: Object

  },

  methods: {

      ValidarRespuesta : function(){


        if (this.allresponses.name != null && this.allresponses.surnames != null)
        {

            let Mutation = {

                formulario: this.FormularioTag,
                question: this.idQuestion,
                validate: true,
                response: this.allresponses.name+' '+this.allresponses.surnames,
                allresponses: this.allresponses
            };

            
            this.$store.commit('actualizarRespuestaFormulario', Mutation);    


        } else {

            let Mutation = {

                formulario: this.FormularioTag,
                question: this.idQuestion,
                validate: false,
                response: null,
                allresponses: this.allresponses
            };

            
            this.$store.commit('actualizarRespuestaFormulario', Mutation);          


        }

      }



  }
}
</script>

<style scoped>

    label {

        font-size:10pt;
        font-weight: bold;

    }


</style>